// extracted by mini-css-extract-plugin
export var alt = "LoginModal-module--alt--b0e09";
export var container = "LoginModal-module--container--0a4c0";
export var desktopOnly = "LoginModal-module--desktopOnly--7dcb6";
export var loginModal = "LoginModal-module--loginModal--151cc";
export var main = "LoginModal-module--main--f4915";
export var mobileOnly = "LoginModal-module--mobileOnly--290cf";
export var textLeft = "LoginModal-module--textLeft--511ef";
export var visuallyHidden = "LoginModal-module--visuallyHidden--b028f";